<div class="h-full">
  <!-- stepper -->
  <rk-stepper [customNextStep]="onNextStep" [customNextStepText]="'assets.next-step' | translate" [nextStepIsDisabled]="nextStepIsDisabled$ | async"
    [@fadeInOut]></rk-stepper>

  <div class="settings-container bg-white px-8">

    <!-- title -->
    <div class="font-bold text-4xl text-center my-13">
      {{ 'assets.images-title' | translate }}
    </div>

    <div class="flex w-full justify-center mb-8">
      <div class="flex justify-center w-full gap-16" [style.flex-direction]="flexDirection$ | async"
        [style.gap.px]="assetMainContainerGap" [class.justify-between]="rightColumnHasItems$ | async">
        <div class="w-full h-fit flex-1">
          <!-- upload logo -->
          <div class="mb-6">
            <rk-logo-upload (rawImageSelected)="onUploadAssetSelected($event)"></rk-logo-upload>
          </div>
          <!-- logo assets -->
          <rk-logo-assets-section (crop)="openCropper($event)" (replace)="replaceAsset($event)"
            [assetWidth]="assetWidth">
          </rk-logo-assets-section>
        </div>
        <div class="w-full h-fit flex-1 flex flex-col">
          <div [class.self-end]="rightColumnHasItems$ | async">
            <!-- upload splashscreen -->
            <div class="mb-6">
              <rk-splashscreen-upload (rawImageSelected)="onUploadAssetSelected($event)"></rk-splashscreen-upload>
            </div>
            <!-- splashscreen assets -->
            <rk-splashscreen-assets-section (crop)="openCropper($event)" (replace)="replaceAsset($event)"
              [assetWidth]="assetWidth">
            </rk-splashscreen-assets-section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>